import React, { useState } from "react"
import types from "prop-types"
import { useModal } from "hooks"
import * as API from "services/api"
import LoadingIndicator from "shared/LoadingIndicator"
import Modal, { DEFAULT_MODAL_STYLE, ModalHeader } from "shared/Modal"
import { TertiaryButton } from "shared/buttons"
import { errorToast } from "shared/toast"
import PublicAnswersList from "./PublicAnswersList"

const MODAL_STYLE = {
  content: {
    ...DEFAULT_MODAL_STYLE.content,
    display: "flex",
    flexDirection: "column",
    maxHeight: "calc(100vh - 2rem)",
    top: "49%",
  },
}


const PublicAnswers = ({ formSubmissionSlug }) => {
  const { modalIsOpen, openModal, closeModal } = useModal()

  const [loading, setLoading] = useState(false)
  const [answersLoaded, setAnswersLoaded] = useState(false)
  const [answers, setAnswers] = useState({})

  const loadAnswers = async () => {
    setLoading(true)
    const response = await API.publicFormSubmissionAnswers({ formSubmissionSlug })

    if (response.ok) {
      setAnswers(response.data)
      setAnswersLoaded(true)
    } else {
      errorToast("Something went wrong. Unable to load answers.")
    }

    setLoading(false)
  }

  const showAnswers = () => {
    if (!answersLoaded) {
      loadAnswers()
    }

    openModal()
  }

  return (
    <>
      <Modal isOpen={modalIsOpen} style={MODAL_STYLE}>
        <ModalHeader
          closeModal={closeModal}
          heading={formSubmissionSlug}
        />
        <div className="flex flex-col gap-8 min-h-0">
          {
            loading
              ? (
                <LoadingIndicator textValue="Loading answers ..." />
              )
              : (
                <PublicAnswersList publicAnswers={answers} />
              )
          }
          <p className="text-xs text-dark">
            A submission may be edited while being processed. The answers
            seen here might differ from those submitted.
          </p>
          <TertiaryButton className="w-full bg-white" onClick={closeModal} text="Close" />
        </div>
      </Modal>
      <TertiaryButton className="w-full bg-white" onClick={showAnswers} text="Review Answers" />
    </>
  )
}

PublicAnswers.propTypes = {
  formSubmissionSlug: types.string.isRequired,
}

export default PublicAnswers
